import React from 'react';
import classes from './RedirectNotice.module.scss';
import Loader from '../Loader/Loader';

// Shown while an a8_redirect=1 auto-redirect is in flight, instead of the bare
// endless loader. Industry-standard pattern: tell the user what's happening and
// give them a manual link in case the automatic navigation doesn't fire.
const RedirectNotice = ({ url }) => (
    <div className={classes.Container} role='status' aria-live='polite'>
        <div className={classes.Dots}>
            <Loader />
        </div>
        <h1 className={classes.Title}>You're being redirected&hellip;</h1>
        <p className={classes.Copy}>
            If you are not redirected automatically,{' '}
            <a className={classes.Link} href={url}>
                tap here
            </a>
            .
        </p>
    </div>
);

export default RedirectNotice;
